import React from 'react';
import * as styles from './index.module.less';
import { TLangType } from '@/utils/type';
import { Caption } from '@/components';
import { PublicArrowRightTail, PublicClose } from 'notta-web-icon';

interface Props {
  lng?: TLangType;
  onClose?: (e) => void;
}

const FEATURE_BANNER_DATA = {
  en: {
    title: '🎉 Introducing Notta Showcase: instantly translate your video into multiple languages for a global reach!',
    btnLabel: 'Learn More',
    btnLink: '/en/showcase',
  },
  ja: {
    title: '🎉 Notta Showcaseーあなたの動画をあっという間に15言語に吹き替え、グローバルへのリーチを手軽に。',
    btnLabel: '詳細情報はこちら',
    btnLink: '/showcase',
  },
};

const FeatureBanner = ({ lng = 'en', onClose }: Props) => {
  const { title = '', btnLabel = '', btnLink = '' } = FEATURE_BANNER_DATA[lng];
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.content_wrapper}>
          <Caption className={styles.title}>{title}</Caption>
          <a href={btnLink} target="_blank" rel="noreferrer" className={styles.btn_link}>
            <span className={styles.btn_label}>{btnLabel}</span>
            <PublicArrowRightTail className={styles.arrow_icon} />
          </a>
        </div>
        <button className={styles.close_btn} onClick={onClose}>
          <PublicClose className={styles.close_icon} />
        </button>
      </div>
    </div>
  );
};

export default FeatureBanner;
